export default __webpack_public_path__ + "static/media/randomotter.bd18fc3c.gif";